import { render, staticRenderFns } from "./GroupTab.vue?vue&type=template&id=bea7cfea&scoped=true&"
import script from "./GroupTab.vue?vue&type=script&lang=js&"
export * from "./GroupTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea7cfea",
  null
  
)

export default component.exports